import React, { useState } from "react";
import { makeStyles } from "@material-ui/core";

import { ReactComponent as RemoveIcon } from "../../../assets/cross.svg";
import LoginForm from "../../auth/login/LoginForm.component";
import { useTranslation } from "react-i18next";
import {
  h4Light,
  h4Medium,
  h5Light,
  h5Medium,
  pointer,
} from "../../../shared/constants";
import RegisterForm from "../../auth/register/RegisterForm.component";

const useStyles = makeStyles({
  container: {
    background: "#FFFFFF",
    boxShadow: "0px 16px 32px rgba(29, 38, 102, 0.08)",
    borderRadius: 32,
    width: 416,
    // Tall enough to fit the sign-in form (its tallest state, ~411px, thanks
    // to the "forgot password" link Register doesn't have) so switching
    // between Sign in / Register / forgot-password doesn't visibly resize
    // the modal, while still growing if content ever needs more room.
    minHeight: 420,
    padding: 48,
    display: "flex",
    flexDirection: "column",

    "@media (max-width:940px)": {
      margin: "0 16px",
      minHeight: "unset",
      padding: 36,
      minHeight: 320,
    },
  },
  header: {
    display: "flex",
    height: 56,
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    marginBottom: 32,
    flexShrink: 0,

    "@media (max-width:940px)": {
      height: 32,
      marginBottom: 24,
    },
  },

  headerTitles: {
    display: "flex",
    alignContent: "center",
    gap: 16,
  },

  headerLogin: {
    ...h4Medium,
    ...pointer,

    "@media (max-width:940px)": {
      ...h5Medium,
    },
  },
  headerRegister: {
    ...h4Light,
    ...pointer,

    "@media (max-width:940px)": {
      ...h5Light,
    },
  },
  notClickedTitle: {
    opacity: 0.64,
  },

  closeIcon: {
    width: 32,
    height: 32,
    cursor: pointer,

    "@media (max-width:940px)": {
      width: 16,
      height: 16,
    },
  },
});

const HeaderAccount = ({ handleClose }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const [isLoginMode, setIsLoginMode] = useState(true);

  const header = (
    <div className={classes.header}>
      <div className={classes.headerTitles}>
        <span
          className={`${classes.headerLogin} ${!isLoginMode ? classes.notClickedTitle : ""
            }`}
          onClick={() => {
            setIsLoginMode(true);
          }}
        >
          {t("auth.sign in")}
        </span>
        <span
          className={`${classes.headerRegister} ${isLoginMode ? classes.notClickedTitle : ""
            }`}
          onClick={() => {
            setIsLoginMode(false);
          }}
        >
          {t("auth.register")}
        </span>
      </div>

      <div className="pointer" onClick={handleClose}>
        <RemoveIcon className={classes.closeIcon} />
      </div>
    </div>
  );

  return (
    <div className={classes.container} dir={t("css.side")}>
      {header}
      {isLoginMode ? (
        <LoginForm handleClose={handleClose} />
      ) : (
        <RegisterForm handleClose={handleClose} />
      )}
    </div>
  );
};

export default HeaderAccount;
